'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormTitle = function FormTitle(_ref) {
    var dueDate = _ref.dueDate,
        requirementSet = _ref.requirementSet;

    var dueDateObject = new Date(dueDate);
    var now = new Date();
    var dueDateString = void 0;
    if (dueDateObject < now) {
        dueDateString = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formMessages.pastDue.dueByDate',
            defaultMessage: 'Due Today'
        });
    } else {
        dueDateString = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formMessages.dueByDate',
            defaultMessage: 'Due by {date}',
            values: {
                date: _react2.default.createElement(_reactIntl.FormattedDate, {
                    value: dueDate,
                    timeZone: 'UTC',
                    year: 'numeric', month: 'short', day: 'numeric' })
            }
        });
    }

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'col-12' },
            _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(_components2.TranslatedRequirementSetTitle, { requirementSet: requirementSet })
            ),
            _react2.default.createElement(
                'p',
                { className: 'dueDate' },
                _react2.default.createElement(
                    'span',
                    null,
                    dueDateString
                )
            )
        )
    );
};
FormTitle.propTypes = {
    dueDate: _propTypes2.default.string.isRequired,
    requirementSet: _propTypes2.default.object.isRequired
};

exports.default = (0, _pacomo.pacomoTransformer)(FormTitle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormTitle.js
// module id = 1345
// module chunks = 0